import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';
import formRules from './formRules';
import Approve from '../../components/Approve';
import ErrorComponent from '../../components/Error';
import {
  injectFormState,
  onChangeFieldText,
  onBlurFieldText,
  formValidate,
} from '../../utils/form';
import { getPaymentInfo, savePaymentInfo } from './actions';
// translate
import messages from './messages';

class PaymentInfo extends Component {
  constructor(props) {
    super(props);

    this.reset = false;

    const attributes = {
      swift: '',
      iban: '',
      bankName: '',
      country: '',
      accountOwner: '',
    };

    this.state = Object.assign(
      {
        attributes,
        showApprove: false,
      },
      injectFormState(formRules, attributes),
    );

    this.onCloseApprove = this.onCloseApprove.bind(this);
    this.formValidate = formValidate.bind(this);
    this.onChangeFieldText = onChangeFieldText.bind(this);
    this.onBlurFieldText = onBlurFieldText.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillMount() {
    this.reset = true;

    const { data } = this.props;
    if (data === null) {
      this.fetchData();
    } else {
      this.fillAttributes(data);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.reset = false;

    const { isFetching, data } = nextProps;
    if (!isFetching && data !== null) {
      this.fillAttributes(data);
    }
  }

  onCloseApprove() {
    this.setState({
      showApprove: !this.state.showApprove,
    });
  }

  onSubmit() {
    this.formValidate(this.state.attributes).then((data) => {
      if (data.status) {
        this.setState({
          showApprove: true,
        });
      }
    });
  }

  onSave() {
    this.setState({
      showApprove: false,
    });

    this.props.dispatch(savePaymentInfo(this.state.attributes));
    localStorage.setItem('settings_full', true);
  }

  fetchData() {
    this.props.dispatch(getPaymentInfo());
  }

  fillAttributes(data) {
    this.setState(
      Object.assign(
        {
          attributes: {
            swift: data.swift || '',
            iban: data.iban || '',
            bankName: data.bank_name || '',
            country: data.country || '',
            accountOwner: data.account_owner || '',
          },
        },
        injectFormState(formRules, this.state.attributes),
      ),
    );
  }

  render() {
    const { intl, isFetching, data, errorMessage, saveSuccess } = this.props;
    const { validation } = this.state.formSchema;
    const {
      swift,
      iban,
      bankName,
      country,
      accountOwner,
    } = this.state.attributes;

    if (isFetching && data === null) {
      return null;
    }

    return (
      <div>
        {this.state.showApprove &&
          <Approve onClose={this.onCloseApprove} onApproved={this.onSave} />}

        {!this.reset &&
          saveSuccess &&
          <div className="popup-form-success">
            <FormattedHTMLMessage {...messages.successText} />
          </div>}

        <form className="popup-form" method="post">

          <label className="label" htmlFor="accountOwner">
            {validation.accountOwner.message &&
              <span className="popup-form-error">
                {intl.formatMessage(validation.accountOwner.message)}
              </span>}
            <input
              type="text"
              name="accountOwner"
              value={accountOwner || ''}
              placeholder={intl.formatMessage(messages.placeholderAccountOwner)}
              onChange={this.onChangeFieldText}
              onBlur={this.onBlurFieldText}
            />
          </label>

          <label className="label" htmlFor="bankName">
            {validation.bankName.message &&
              <span className="popup-form-error">
                {intl.formatMessage(validation.bankName.message)}
              </span>}
            <input
              type="text"
              name="bankName"
              value={bankName || ''}
              placeholder={intl.formatMessage(messages.placeholderBankName)}
              onChange={this.onChangeFieldText}
              onBlur={this.onBlurFieldText}
            />
          </label>

          <label className="label" htmlFor="country">
            {validation.country.message &&
              <span className="popup-form-error">
                {intl.formatMessage(validation.country.message)}
              </span>}
            <input
              type="text"
              name="country"
              value={country || ''}
              placeholder={intl.formatMessage(messages.placeholderCountry)}
              onChange={this.onChangeFieldText}
              onBlur={this.onBlurFieldText}
            />
          </label>

          <label className="label" htmlFor="iban">
            {validation.iban.message &&
              <span className="popup-form-error">
                {intl.formatMessage(validation.iban.message)}
              </span>}
            <input
              type="text"
              name="iban"
              value={iban || ''}
              placeholder={intl.formatMessage(messages.placeholderIban)}
              onChange={this.onChangeFieldText}
              onBlur={this.onBlurFieldText}
            />
          </label>

          <label className="label" htmlFor="swift">
            {validation.swift.message &&
              <span className="popup-form-error">
                {intl.formatMessage(validation.swift.message)}
              </span>}
            <input
              type="text"
              name="swift"
              value={swift || ''}
              placeholder={intl.formatMessage(messages.placeholderSwift)}
              onChange={this.onChangeFieldText}
              onBlur={this.onBlurFieldText}
            />
          </label>

          <button
            className="trans"
            type="button"
            disabled={isFetching}
            onClick={this.onSubmit}
          >
            {intl.formatMessage(messages.submitButton)}
          </button>
          {errorMessage &&
            !isFetching &&
            <ErrorComponent>{errorMessage}</ErrorComponent>}
        </form>
      </div>
    );
  }
}

PaymentInfo.defaultProps = {
  data: null,
  errorMessage: false,
};

PaymentInfo.propTypes = {
  intl: intlShape.isRequired,
  dispatch: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  errorMessage: PropTypes.any,
  saveSuccess: PropTypes.bool.isRequired,
  data: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    isFetching: state.get('paymentInfo').isFetching,
    errorMessage: state.get('paymentInfo').errorMessage,
    saveSuccess: state.get('paymentInfo').saveSuccess,
    data: state.get('paymentInfo').data,
  };
}

export default connect(mapStateToProps)(injectIntl(PaymentInfo));



// WEBPACK FOOTER //
// ./src/containers/PaymentInfo/index.js